// Per-filter-name descriptor: the small set of bespoke behaviours a handful of
// filters need, kept as declarative data instead of hardcoded `name === '…'` checks
// scattered through FilterEditor / filterParams. Entries are added as each special
// is migrated (3c); 3b extends this with option-loading fields later.
export type FilterDescriptor = {
  // Hide the empty/filled operator radios for this filter.
  suppressOperators?: boolean;
  // This multi-select's value is self-encoded (JSON) in the URL params.
  selfEncoded?: boolean;
};

const filterDescriptors: Record<string, FilterDescriptor> = {
  // "Missing data" is itself the empty/filled predicate, so the operator radios
  // (which would let you pick empty vs filled) make no sense for it.
  missing_data: { suppressOperators: true },
  // A multi-select that carries its own `[a,b]` URL encoding (see
  // serializeFiltersToSearch), so its params value must not be re-wrapped as an array.
  last_reminder_step_type: { selfEncoded: true },
};

const EMPTY_DESCRIPTOR: FilterDescriptor = {};

// Always returns a descriptor (the empty one for unregistered filters) so callers
// can read its fields without guarding for undefined.
export const getFilterDescriptor = (name: string): FilterDescriptor =>
  filterDescriptors[name] ?? EMPTY_DESCRIPTOR;
